var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailStackIcon = function SvgNewcsDashboardCrashanalysisIssuedetailStackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_stack_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M705 264h12v14h-12z",
    "data-name": "\\u77E9\\u5F62 378"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_stack_icon_svg__a)",
    transform: "translate(-705 -264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M716.914 273.402a.75.75 0 0 1-.276.99l-.04.022-5.249 2.75a.75.75 0 0 1-.649.023l-.047-.023-5.249-2.75a.75.75 0 0 1 .655-1.349l.041.02 4.9 2.567 4.9-2.567a.75.75 0 0 1 1.012.316Zm0-2.75a.75.75 0 0 1-.276.99l-.04.022-5.249 2.75a.75.75 0 0 1-.649.022l-.047-.022-5.249-2.75a.75.75 0 0 1 .655-1.349l.041.02 4.9 2.567 4.9-2.567a.75.75 0 0 1 1.012.316Zm-6.262-5.816a.75.75 0 0 1 .7 0l5.249 2.75a.75.75 0 0 1 0 1.328l-5.249 2.75a.75.75 0 0 1-.7 0l-5.249-2.75a.75.75 0 0 1 0-1.328Zm.348 1.511-3.633 1.9 3.633 1.9 3.633-1.9Z"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailStackIcon;